export default "__VITE_ASSET__CXIhlUK$__"